import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants'
import { QuotaService } from '../services/quota.service'
import type { QuotaCurrentResponse } from '../../types'

export const useQueryGetCurrentQuota = () => {
	return useQuery<QuotaCurrentResponse>({
		queryKey: QUERY_KEYS.QUOTA.CURRENT(),
		queryFn: () => QuotaService.getCurrentQuota(),
		staleTime: 0,
		refetchOnMount: true,
		refetchOnWindowFocus: true,
	})
}
